import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { authGuard } from './core/guards/auth.guard';
import { AuthorizedGuard } from './core/guards/authorized.guard';
import { EndRevisionGuard } from './core/guards/end-revision.guard';
import { layoutResolver } from './core/layout/layout-resolver.resolver';

const childrenRoutes: Routes = [
  {
    path: 'tablero',
    loadChildren: () =>
      import('./modules/my-board/my-board.module').then((m) => m.MyBoardModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'asistencias',
    loadChildren: () =>
      import('./modules/core/attendance/attendance.module').then(
        (m) => m.AttendanceModule
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'solicitudes',
    loadChildren: () =>
      import('./modules/core/requests/requests.module').then(
        (m) => m.RequestsModule
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'indicadores',
    loadChildren: () =>
      import('./modules/indicators/indicators.module').then(
        (m) => m.IndicatorsModule
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'evaluacion',
    loadChildren: () =>
      import('./modules/evaluations/evaluations.module').then(
        (m) => m.EvaluationsModule
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'contratos',
    loadChildren: () =>
      import('./modules/contract/contract.module').then((m) => m.ContractModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'tareo',
    loadChildren: () =>
      import('./modules/task/tasks.module').then((m) => m.TasksModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
    canDeactivate: [EndRevisionGuard],
  },
  {
    path: 'coordinadores',
    loadChildren: () => import('./modules/client/client.module').then((m) => m.ClientModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  // // !!!!!!! BORRAR ESTOS MENÚS:
  {
    path: 'configuraciones',
    loadChildren: () =>
      import('./modules/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },

  // {
  //   path: 'plantillas',
  //   loadComponent: () =>
  //     import('./modules/contract/components/template-crud/template-crud.component').then((m) => m.TemplateCrudComponent),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },

  // !!!!!!! BORRAR ESTOS MENÚS:
  {
    path: 'proyectos-requerimientos',
    loadChildren: () =>
      import(
        './modules/project-requirements/projects-requirements.module'
      ).then((m) => m.ProjectsRequirementsModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: 'colaboradores',
    loadChildren: () =>
      import('./modules/core/collaborators/collaborators.module').then(
        (m) => m.CollaboratorsModule
      ),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  // {
  //   path: 'empresas',
  //   loadChildren: () =>
  //     import('./modules/company/company.module').then((m) => m.CompanyModule),
  //   canActivate: [authGuard, AuthorizedGuard],
  //   canLoad: [authGuard],
  // },
  {
    path: "celebraciones",
    loadChildren: () =>
      import('./modules/celebrations/celebrations.module').then((m) => m.CelebrationsModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: "comunicaciones",
    loadChildren: () =>
      import('./modules/communications/communications.module').then((m) => m.CommunicationsModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: "certificados",
    loadChildren: () =>
      import('./modules/certificates/certificates.module').then((m) => m.CertificatesModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: "organigrama",
    loadChildren: () =>
      import('./modules/org-chart/org-chart.module').then((m) => m.OrgChartModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard]
  },
  {
    path: "tesoreria",
    loadChildren: () => import("./modules/treasury/treasury.module").then((m) => m.TreasuryModule),
    canActivate: [authGuard, AuthorizedGuard],
    canLoad: [authGuard],
  },
  {
    path: "notificaciones",
    loadChildren: () =>
      import("./core/notifications/notifications.module").then((m) => m.NotificationsModule),
    canActivate: [authGuard],
    canLoad: [authGuard],
    data: {
      containerEnabled: true,
    },
  },
  {
    path: "vacaciones",
    loadChildren: () => import('./modules/vacations/vacations.module').then((m) => m.VacationsModule),
    canActivate: [authGuard],
    canLoad: [authGuard]
  },
  {
    path: "planilla",
    loadChildren: () => import('./modules/payroll/payroll.module').then((m) => m.PayrollsModule),
    canActivate: [authGuard],
    canLoad: [authGuard]
  },
  {
    path: "organigrama",
    loadChildren: () => import('./modules/org-chart/org-chart.module').then((m) => m.OrgChartModule),
    canActivate: [authGuard],
    canLoad: [authGuard]
  },
  {
    path: 'common',
    loadChildren: () =>
      import('./core/common-pages/common-pages.module').then(
        (m) => m.CommonPagesModule
      ),
    canActivate: [authGuard],
    canLoad: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'common',
  },
];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./core/auth/auth.module').then((m) => m.AuthModule),
  },
  // {
  //   path: 'service-unaviable',
  //   component : ServiceUnaviableComponent,
  //   // pathMatch: 'full',
  // },
  {
    path: '',
    component: LayoutComponent,
    children: childrenRoutes,
    canActivate: [authGuard],
    resolve: {
      preferences: layoutResolver
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
